import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_BULK_VARIANTS = registerQuery({
  fieldName: 'bulkVariants',
  fetcher: () => {
    return http.get('global/styles/variants/v1/definitions');
  }
});
export const GET_VARIANT_DEFINITION = registerQuery({
  fieldName: 'variantDefinition',
  args: ['variantDefinitionName'],
  fetcher({
    variantDefinitionName
  }) {
    return http.get(`global/styles/variants/v1/definitions/${variantDefinitionName}`);
  }
});